// eslint-disable-next-line strict
export default null;



// WEBPACK FOOTER //
// ../lib/helpers/null.js